import type {
  ApiProjectSite,
  ApiReturnProject,
} from '@highimpact-frontend/api-types';

export function getProjectFromSiteId(
  site_id: number,
  project_sites: ApiProjectSite[],
  projects: ApiReturnProject[]
): ApiReturnProject | undefined {
  const project_site = project_sites.find(
    (entry) => entry.site_id === site_id
  );
  if (!project_site) {
    return undefined;
  }
  return projects.find((project) => project.id === project_site.project_id);
}
